import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  standalone: false,
})

/**
 * Usage:
 * <input type="text" [(ngModel)]="search">
 *
 * <tr *ngFor="let item of mf.data | filterBy: {fieldName: searchValue}>
 *
 * Example:
 * data = [{ Employee: "Axel", FirstName: "Axel", LastName: "Jensen" }];
 * <tr *ngFor="let item of mf.data | filterBy: {Employee: search}>
 */
export class FilterByPipe implements PipeTransform {
  private filterByString(filter: string) {
    filter = filter.toLowerCase();
    return (value: string) => {
      return !filter || value.toLowerCase().indexOf(filter) !== -1;
    };
  }

  private filterByObject(filter: Record<string, any>) {
    return (value: Record<string, any>) => {
      for (const key in filter) {
        if (!value || !value.hasOwnProperty(key)) {
          return false;
        }

        if (filter[key] == undefined || filter[key] == '') {
          continue;
        }

        const itemValue = value[key];
        const filterValue = filter[key];
        const type = typeof itemValue;
        let isMatching;

        if (type === 'string') {
          isMatching = this.filterByString(filterValue as string)(
            itemValue as string
          );
        } else if (type === 'object') {
          isMatching = this.filterByObject(filterValue as Record<string, any>)(
            itemValue as Record<string, any>
          );
        } else {
          isMatching = this.filterDefault(filterValue)(itemValue);
        }

        if (!isMatching) {
          return false;
        }
      }

      return true;
    };
  }

  /**
   * Defatul filterDefault function
   *
   * @param filter
   * @returns {(value:any)=>boolean}
   */
  private filterDefault(filter: any) {
    return (value: any) => {
      return !filter || filter == value;
    };
  }

  private isNumber(value: string | number) {
    const numericValue = Number(value);
    return !Number.isNaN(numericValue) && Number.isFinite(numericValue);
  }

  transform(array: any[], filter: any): any[] | undefined {
    const type = typeof filter;

    if (array == null || array.length === 0) return;

    if (type === 'string') {
      if (this.isNumber(filter)) {
        return array.filter(this.filterDefault(filter));
      }

      return array.filter((value) =>
        this.filterByString(String(filter))(String(value ?? ''))
      );
    }

    if (type === 'object') {
      return array.filter(this.filterByObject(filter as Record<string, any>));
    }

    return array.filter(this.filterDefault(filter));
  }
}
